import { useEffect, useRef, useState } from "react";
import { ErnotsConfig } from "../../../../ErnotsConfig";
import { useAppDispatch } from "../../../../store/hooks";
import { Book } from "../../../../rest/models";
import { makeApiRequest, RequestStatus } from "../../../../api_request/api_request";
import { RequestStatusDisplay } from "../../../CommonComponents";
import { Button } from "../../../RequestRespectingInputs";
import { recalculateBlocksAndSentences } from "../../utils";

/**
 * Opens a translation window when the book has unsaved changes.
 * Records the sentences in the user's arbitrary_text field, then opens the page that views them
 * (but with the showLines param, so that they'd be displayed using a <ul>, rather than <pre>).
 */
export function QueryTranslationButtonUnsaved(props: Props)
{
    const appDispatch = useAppDispatch();

    const url = `arbitrary_text/`;
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);
    const windowOpened = useRef(false);

    useEffect(function()
    {
        const success = request?.success;
        const atid = request?.responseText;
        
        if (success && atid && !windowOpened.current)
        {
            const params = new URLSearchParams();
            params.set('atid', atid ?? '');
            params.set('showLines', 'true');
            params.set('bookTitle', props.book.title);

            const url2 = `${ErnotsConfig.APIURLPrefix}${url}?${params}`;
            const url3 = props.googlify(url2);

            window.open(url3, '_blank');

            windowOpened.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request?.success, request?.responseText]);

    return (
        <>
            <Button
                disabled={!props.book.source_text}
                onClick={function(e)
                {
                    const book2 = recalculateBlocksAndSentences(props.book, appDispatch);

                    const allSentenceText =  book2
                        .sentence_set
                        .map(s => s.text)
                        .join('\n');

                    makeApiRequest({
                        endpoint: url,
                        method: 'POST',
                        postData: {text: allSentenceText},
                        dispatch: appDispatch,
                        lifeCycleCallback: setRequest
                    });

                    windowOpened.current = false;
                }}>{props.buttonText}</Button>
            <RequestStatusDisplay request={request} success_message=''/>
        </>
    );
}

interface Props
{
    book: Book;
    buttonText: string;
    tlCode: string;
    googlify: (url: string) => string;
}